// extracted by mini-css-extract-plugin
module.exports = {"commonFooter":"footer_commonFooter__tdJSY","tab":"footer_tab__GMNTP","messagesCounter":"footer_messagesCounter__JEIFP"};